import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { fetchRecoveryOverview } from '@/slices/bookkeeperSlice';
import { getAutoRecoveryChartsData } from '@/services/bookkeeperService';
import BoardPanel from '@/components/Cluster/BoardPanel';
import Summary from './Summary';

function AutoRecover({ fetchRecoveryOverview }) {
  const [searchParams] = useSearchParams();
  const clusterName = searchParams.get('name');

  useEffect(() => {
    if (clusterName) {
      fetchRecoveryOverview(clusterName);
    }
  }, [fetchRecoveryOverview, clusterName]);

  if (!clusterName) return null;

  return (
    <Root>
      <Summary />
      <BoardPanel
        getChartsData={async (params) =>
          await getAutoRecoveryChartsData({ clusterName, ...params })
        }
      />
    </Root>
  );
}

export default connect(null, {
  fetchRecoveryOverview,
})(AutoRecover);

const Root = styled.div`
  padding-right: 20px;
`;
